import AxiosUtil from '../utils/axiosUtil';

/** 조기폐차 API */
const BASE_URI = '/apis/early-scrap';

export const EarlyScrapService = (function () {
  let instance;

  function init() {
    return {
      /** 점검번호 채번: YYMMDD + 000000~999999 */
      getNextInspectNumber: async function ({ shopId } = {}) {
        const query = shopId != null ? `shopId=${shopId}` : '';
        return await AxiosUtil.Async.get(
          `${BASE_URI}/inspect-number/next`,
          query
        );
      },
      register: async function (data, files = null) {
        return await AxiosUtil.Async.multipart(`${BASE_URI}/data`, data, files);
      },
    };
  }

  return {
    getInstance: function () {
      if (!instance) instance = init();
      return instance;
    },
  };
})();
